import { ProfileAISummaryWidgetFooterCopyButton } from '../ProfileAISummaryWidgetFooterCopyButton'
import { ProfileAISummaryWidgetFooterRefreshButton } from '../ProfileAISummaryWidgetFooterRefreshButton'

import * as styles from './ProfileAISummaryWidgetFooter.module.css'

function ProfileAISummaryWidgetFooter({
  canRefresh,
  contentRef,
  loading,
  onRefresh,
}) {
  return (
    <div className={styles.ProfileAISummaryWidgetFooter}>
      <ProfileAISummaryWidgetFooterCopyButton contentRef={contentRef} />
      {canRefresh ? (
        <ProfileAISummaryWidgetFooterRefreshButton
          loading={loading}
          onClick={onRefresh}
        />
      ) : null}
    </div>
  )
}

export default ProfileAISummaryWidgetFooter
